import React, { useEffect, useState } from "react";
import './devicelist.css';
import getDevicesByCompany from "../api/getDevicesByCompany";
import { useAuth } from "../login/authProvider";
import getAllDevicesForAdmin from "../api/getAllDevicesForAdmin";
import { getAllCompanies } from "../api/endpoints";
import { calculateDaysLeft, getServiceStatus, getCommunityStatus, getActiveStatus, sortDevicesByDaysLeft } from "./deviceFunctions";
import { useCompanyScope } from "../context/CompanyScopeContext";



const DeviceList = () => {
  const { user, token } = useAuth();
  const [devices, setDevices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showOnlyActive, setShowOnlyActive] = useState(false);
  const [filter, setFilter] = useState(""); 
  const [searchQuery, setSearchQuery] = useState("");
  const [allDevices, setAllDevices] = useState([]);
  const [allCompanies, setAllCompanies] = useState([]);
  // const [selectedCompany, setSelectedCompany] = useState(user?.company || "");
  const { selectedCompany, setSelectedCompany } = useCompanyScope();
  const [expandedDeviceId, setExpandedDeviceId] = useState(null);
  const [showEmailFormForId, setShowEmailFormForId] = useState(null);
const [emailMessage, setEmailMessage] = useState("");
const [confirmedDeviceId, setConfirmedDeviceId] = useState(null);


const [typeFilter, setTypeFilter] = useState('all');



  const company = user?.company;
  const API_URL = process.env.REACT_APP_API_URL;


  const normalize = (name) => {
    return name
      ?.trim()                        
      .replace(/\s+/g, " ")            
      .replace(/\bAB\b\.?$/i, "")       
      .trim()                  
      .toLowerCase();             
  };
  
  
  const toggleExpanded = (deviceId) => {
    if (expandedDeviceId === deviceId) {
      setExpandedDeviceId(null);
      setShowEmailFormForId(null);
      setEmailMessage("");
      setConfirmedDeviceId(null);
    } else {
      setExpandedDeviceId(deviceId);
      setShowEmailFormForId(null);
      setEmailMessage("");
      setConfirmedDeviceId(null);
    }
  };
  
  

  const getIMEIColumnName = (device) => {
    return Object.keys(device).find((key) => key.startsWith("IMEI")) || "Ingen IMEI-kolumn hittades";
  };



  const formatDate = (date) => {
    if (!date) return "Datum saknas";
    return new Date(date).toISOString().split("T")[0];
  };




  useEffect(() => {
    if (user?.isAdmin) {
      const fetchCompanies = async () => {
        try {
          const data = await getAllCompanies(token);
          setAllCompanies(data);
        } catch (error) {
          console.error("Kunde inte hämta företag:", error);
          setError("Kunde inte hämta företag.");
        }
      };
      fetchCompanies();
    }
  }, [user?.isAdmin, token]);



   
  useEffect(() => {
    const fetchDevices = async () => {
      setLoading(true);
      try {
        const data = await getAllDevicesForAdmin(token); 
        //const sorted = sortDevicesByDaysLeft(data);

      const activeOnly = data.filter((d) => d.Aktivenhet === "JA");
      const sorted = sortDevicesByDaysLeft(activeOnly);

        setAllDevices(sorted);
        setDevices(sorted);
      } catch (error) {
        console.error("Kunde inte hämta enheter:", error);
        setError("Kunde inte hämta enheter.");
      } finally {
        setLoading(false);
      }
    };
    if (user?.isAdmin) {
      fetchDevices(); 
    } else {

   //   getDevicesByCompany(token)
   getDevicesByCompany(token, selectedCompany || user?.company)

        .then((data) => {
          const activeOnly = data.filter((d) => d.Aktivenhet === "JA");
        const sorted = sortDevicesByDaysLeft(activeOnly);
setAllDevices(sorted);
setDevices(sorted);
        })
        .catch(() => setError("Kunde inte hämta enheter."))
        .finally(() => setLoading(false));
    }
  }, //[user?.isAdmin, token]); },
   [user?.isAdmin, token, selectedCompany, user?.company]);

  




const handleCompanyChange = (event) => {
  setSelectedCompany(event.target.value);
};

const handleResetFilters = () => {
  setSearchQuery('');
  setFilter('');
  setTypeFilter('all');
 };




  const toggleShowActive = () => setShowOnlyActive(!showOnlyActive);

  const handleFilterChange = (e) => setFilter(e.target.value);

  const handleSearchChange = (e) => setSearchQuery(e.target.value.toLowerCase());



  useEffect(() => {
    if (selectedCompany) {
      const normalizedSelected = normalize(selectedCompany);
      const filtered = allDevices.filter(device => normalize(device.Title) === normalizedSelected);
      setDevices(filtered);
    } else {
      const normalizedUserCompany = normalize(user?.company);
      const filtered = allDevices.filter(device => normalize(device.Title) === normalizedUserCompany);
      setDevices(filtered);
    }
  }, [selectedCompany, allDevices, user?.company]);
  
  
const getConcept = (device) => ((device.Koncept || '') + '').toLowerCase();

  const filteredDevices = devices
  .filter((device) => {
    const companyToShow = selectedCompany || user?.company;
    if (normalize(device.Title) !== normalize(companyToShow)) return false;


    if (showOnlyActive && device.Aktivenhet !== "JA") return false;

       const concept = getConcept(device); // "community mobil" / "community dator"
    if (typeFilter === 'mobil' && !concept.includes('mobil')) return false;
    if (typeFilter === 'dator' && !concept.includes('dator')) return false;

    const searchTerm = searchQuery.toLowerCase();
    return (
      device.Avtalsnummer?.toLowerCase().includes(searchTerm) ||
      `${device.Tillverkare} ${device.Modell}`.toLowerCase().includes(searchTerm) ||
      device.Anv_x00e4_ndare?.toLowerCase().includes(searchTerm) || 
      device[getIMEIColumnName(device)]?.toLowerCase().includes(searchTerm)
    );
 })
.sort((a, b) => {
  if (filter === "user") {
    const nameA = a.Anv_x00e4_ndare || "";
    const nameB = b.Anv_x00e4_ndare || "";
    return nameA.localeCompare(nameB, 'sv'); // 'sv' = svensk sortering
  }
   
    if (filter === "daysLeft") {
      const daysA = calculateDaysLeft(a.Avtalsstart, a.Avtalsslut);
      const daysB = calculateDaysLeft(b.Avtalsstart, b.Avtalsslut);
      if (isNaN(daysA) || isNaN(daysB)) return 0;
      return daysA - daysB;
    }

    return 0;
  });



  if (loading) return <p>Laddar enheter...</p>;
  if (error) return <p>{error}</p>;



  return (
    <div>
      
      <div className="device-header">
  <h2 className="device-list-title">
    {`Enheter för ${selectedCompany || user?.company}`}
  </h2>

{(user?.isAdmin || (Array.isArray(user?.companies) && user.companies.length > 1)) && (
  <select
    id="company-select"
    value={selectedCompany || ""}
    onChange={(e) => setSelectedCompany(e.target.value)}
  >
    {(user?.isAdmin ? allCompanies : (user?.companies || [user?.company]).filter(Boolean)).map((companyName, index) => (
      <option key={index} value={companyName}>
        {companyName}
      </option>
    ))}
  </select>
)}
</div>

<hr className="hr"></hr>

<div className="mypages-buttons">
  <a href="https://forms.office.com/Pages/ResponsePage.aspx?id=rmCL44UwIU6awvX2L-FcDWy3WVNaUE9GtvQLL3sGkyVUMVg5MzVBWldLVzNRSjlaRVM4UDNXR0IyMy4u" className="mypages-button" target="_blank">Onboarding</a>
  <a href="https://forms.office.com/Pages/ResponsePage.aspx?id=rmCL44UwIU6awvX2L-FcDWy3WVNaUE9GtvQLL3sGkyVUM0RRWUM3QzlBTkE5WDFINldGUlRCODNKSy4u" className="mypages-button" target="_blank">Offboarding</a>
  <a href="https://forms.office.com/Pages/ResponsePage.aspx?id=rmCL44UwIU6awvX2L-FcDWy3WVNaUE9GtvQLL3sGkyVUQ1pDT0NMS0RYRk9KNUxTMzZXMEJTUVYzSy4u" className="mypages-button" target="_blank">Anmäl skada eller förlust</a>
  <a href="https://forms.office.com/Pages/ResponsePage.aspx?id=rmCL44UwIU6awvX2L-FcDWy3WVNaUE9GtvQLL3sGkyVUMlYxMlFPTk0zODJYVUs4R1NKRkFKUDBFOS4u" className="mypages-button" target="_blank">Anmäl retur av enheter</a>
  <a href="https://forms.office.com/Pages/ResponsePage.aspx?id=rmCL44UwIU6awvX2L-FcDWy3WVNaUE9GtvQLL3sGkyVUQldBQTI1VEpPVDJQTlhFMDlKNUtHNFZCUi4u" className="mypages-button" target="_blank">Anmäl skada inför retur</a>
</div>
      
      <div className="filter-bar">
   
        <input
          type="text"
          placeholder="Sök .."
          value={searchQuery}
          onChange={handleSearchChange}
        />
        <select className="custom-select" value={filter} onChange={handleFilterChange}>
          <option value="">Sortera på..</option>
          <option value="user">Användare (A-Ö)</option>
          <option value="daysLeft">Dagar kvar</option>
        </select>

       <select className="custom-select"
  value={typeFilter}
  onChange={(e) => {
  const v = e.target.value;
  setTypeFilter(v === 'mobil' || v === 'dator' ? v : 'all');
}}
>
  <option value="all">Alla typer</option>
  <option value="mobil">Endast mobiler</option>
  <option value="dator">Endast datorer</option>
</select>

  <button
    onClick={handleResetFilters}
    className="reset-filters-button"
  >
    Rensa filter
  </button>

      </div>

    

      <div className="device-list">
        {Array.isArray(filteredDevices) && filteredDevices.length > 0 ? (
          filteredDevices.map((device) => {
        
            const imeiColumn = getIMEIColumnName(device);
           // const communityStatus = getCommunityStatus(device.statusCommunity);

            return (
              <React.Fragment key={device.id}>
                <div className="device-card">
   
                  <div className="device-card-row">
                    <span>Status:</span>
                   <div><span className={`device-status ${getActiveStatus(device.Aktivenhet).className}`}>
      {getActiveStatus(device.Aktivenhet).text}
    </span></div> </div>
    <div className="device-card-row">
                    <span>Avtal:</span>
                    <div>{device.Avtalsnummer || "Saknas"}</div>
                  </div>
                  <div className="device-card-row">
                    <span>Användare:</span>
                    <div>{device.Anv_x00e4_ndare || "Okänd"}</div>
                  </div>
                  <div className="device-card-row">
                    <span>Enhet:</span>
                    <div>{`${device.Modell}` || "Okänd"}</div>
                  </div>
                  <div className="device-card-row">
                    <span>Avtalsstart:</span>
                    <div>{formatDate(device.Avtalsstart)}</div>
                  </div>
                  <div className="device-card-row">
                    <span>Avtalsslut:</span>
                    <div>{formatDate(device.Avtalsslut)}</div>
                  </div>
                  <div className="device-card-row">
                    <span>Dagar kvar:</span>
                    <div>{calculateDaysLeft(device.Avtalsstart, device.Avtalsslut, device.Aktivenhet === "JA")}
                    </div>
                  </div>
                </div>
           
                <div
  className={`device-box ${device.Aktivenhet !== "JA" ? "disabled-box" : ""}`}
  onClick={() => {
    if (device.Aktivenhet === "JA") {
      toggleExpanded(device.id);
    }
  }}
>

                <div className="device-header">
                <div className="status-table">
  <div className="status-cell">
    <span className={`device-status ${getActiveStatus(device.Aktivenhet).className}`}>
      {getActiveStatus(device.Aktivenhet).text}
    </span>
  </div>
  
  {device.Service === "Service pågår" && (
    <div className="status-cell">
      <span className="service-status">
        Service pågår
      </span>
    </div>
  )}

  <div className="status-cell">
    <span className={`community-status ${getCommunityStatus(device.StatusCommunity).className}`}>
      {getCommunityStatus(device.StatusCommunity).text}
    </span>
  </div>
</div>



                  </div>
                  <div className="device-table-container">
                    <table className="device-table">
                      <thead>
                        <tr>
                       
                          <th>Avtal</th>
                          <th>Koncept</th>
                          <th>Användare</th>
                          <th>Enhet</th>
                          <th>IMEI/Serienummer</th>
                          <th>Avtalsstart</th>
                          <th>Avtalsslut</th>
                          <th>Dagar kvar</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                    
                          <td>{device.Avtalsnummer}</td>
                          <td>{device.Koncept}</td>
                          <td>{device.Anv_x00e4_ndare}</td>
                          <td>{device.Tillverkare} {device.Modell}</td>
                          <td>{device[imeiColumn] || "Ingen IMEI tillgänglig"}</td>
                          <td>{formatDate(device.Avtalsstart)}</td>
                          <td>{formatDate(device.Avtalsslut)}</td>
                          <td>{calculateDaysLeft(device.Avtalsstart, device.Avtalsslut, device.Aktivenhet === "JA")}</td>

                        </tr>
                      </tbody>
                    </table>
                    {expandedDeviceId === device.id && (
  <div className="expanded-content">
    {confirmedDeviceId === device.id ? (
      <div className="email-confirmation-text">
        Din begäran om namnändring är nu mottagen hos Community.
      </div>
    ) : showEmailFormForId === device.id ? (
      <div className="email-form-wrapper">
        <input
          type="text"
          placeholder="Skriv namnet på den nya användaren här och skicka till Community.."
          value={emailMessage}
          onChange={(e) => setEmailMessage(e.target.value)}
          className="email-input"
          onClick={(e) => e.stopPropagation()}
        />
        <button
          className="custom-action-button"
          disabled={!emailMessage.trim()}
          onClick={async (e) => {
            e.stopPropagation();

            const imeiColumn = getIMEIColumnName(device);

            const payload = {
              deviceId: device.id,
              imei: device[imeiColumn] || "Okänt",
              phone: device.Modell || "Okänt",
              oldUser: device.Anv_x00e4_ndare || "Okänd",
              newUser: emailMessage,
              company: user?.company || "Okänt",
              sender: user?.email || "Okänd"
            };
            

            const res = await fetch(`${API_URL}/send-name-change-request`, {
              method: "POST",
              headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json"
              },
              body: JSON.stringify(payload),
            });

            const result = await res.text();

            if (res.ok) {
              setConfirmedDeviceId(device.id);  
              setEmailMessage("");
              setShowEmailFormForId(null);
            } else {
              alert("Något gick fel: " + result);
            }
          }}
        >
          Skicka
        </button>
      </div>
    ) : (
      <div className="email-button-wrapper">
        <button
          className="custom-action-button"
          onClick={(e) => {
            e.stopPropagation();
            setShowEmailFormForId(device.id);
            setConfirmedDeviceId(null); 
          }}
        >
          Begär namnbyte
        </button>
      </div>
    )}
  </div>
)}




                  </div>
                </div>
              </React.Fragment>
            );
          })
        ) : (
          <p>Inga enheter matchar dina filter.</p>
        )}
      </div>
    </div>
  );
};

export default DeviceList;